import React, { useContext, useEffect } from "react";
import { S3_ENDPOINT } from "../../utils";
import { CourseAccessesContext } from "../../context/CourseAccessesContext";

const FinalExamTarget = ({ course_id, children, buttonTitle, handleClick }) => {
  const { course_accesses, getCourseAccesses } = useContext(
    CourseAccessesContext,
  );

  useEffect(() => {
    getCourseAccesses();
  }, []);

  const getSrc = (final_exam) => {
    return `${S3_ENDPOINT}/final-${
      String(final_exam).toLowerCase().includes("upper")
        ? "upper-body"
        : "lower-body"
    }.jpg`;
  };

  const renderTarget = () => {
    if (Array.isArray(course_accesses)) {
      const currentAccess = course_accesses.find(
        (course_access) =>
          parseInt(course_access.course_id) === parseInt(course_id),
      );
      if (currentAccess) {
        return (
          <div className="row">
            <div className="col-6">
              <img
                alt="Final Exam Target"
                src={getSrc(currentAccess.final_exam)}
                style={{ maxWidth: 300, height: "auto" }}
                className="w-100 m-auto d-block"
              />
            </div>
            <div className="col-6">
              {children}
              <p className="large">Tu examen deberá ser sobre</p>
              <div className="container-fluid px-0 mb-4">
                <span className="bg-gradient-landing p-3 py-2 h3 mb-3">
                  {currentAccess.final_exam}
                </span>
              </div>
              <div className="d-flex">
                <button onClick={handleClick} className="btn btn-primary me-2">
                  {buttonTitle}
                </button>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn bg-primary-dark text-white"
                  href="https://tbmcerts.s3.us-west-1.amazonaws.com/TBM-Lineamientos-Examen-Final.pdf"
                >
                  Lineamientos de tu Examen Final
                </a>
              </div>
            </div>
          </div>
        );
      }
    }
  };

  return <div className="container-fluid px-0">{renderTarget()}</div>;
};

export default FinalExamTarget;
